import React, { useEffect,useState } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
//third party
import { useSelector, useDispatch } from 'react-redux'
import { totalOff } from '../service/webinarsService'
import Countdown from 'react-countdown';

const Home = () => {

    const user = useSelector((state) => state.user)
    const [getTotalOff, setTotalOff] = useState(0)


    const handleGetTotalCode = async () => {
        try {
            const { status, data } = await totalOff();
            if (status === 200) {
                if (Date.now() <= (data.totalOff.date * 1000 + data.totalOff.time * 60 * 60 * 1000)) {
                    setTotalOff(data.totalOff)
                }
            }
        }
        catch (ex) {
        }
    }

    useEffect(() => {
        handleGetTotalCode()
        document.querySelector(".header").style.display = "none"
        document.querySelector(".footer").style.display = "none"
        return (
            () => {
                document.querySelector(".header").style.display = "flex"
                document.querySelector(".footer").style.display = "block"
            }
        )
    }, [])
    useEffect(() => {

        var colors = new Array(
            [62, 35, 255],
            [60, 255, 60],
            [255, 35, 98],
            [45, 175, 230],
            [255, 0, 255],
            [255, 128, 0]);

        var step = 0;
        //color table indices for: 
        // current color left
        // next color left
        // current color right
        // next color right
        var colorIndices = [0, 1, 2, 3];

        //transition speed
        var gradientSpeed = 0.002;

        function updateGradient() {

            if ($ === undefined) return;

            var c0_0 = colors[colorIndices[0]];
            var c0_1 = colors[colorIndices[1]];
            var c1_0 = colors[colorIndices[2]];
            var c1_1 = colors[colorIndices[3]];

            var istep = 1 - step;
            var r1 = Math.round(istep * c0_0[0] + step * c0_1[0]);
            var g1 = Math.round(istep * c0_0[1] + step * c0_1[1]);
            var b1 = Math.round(istep * c0_0[2] + step * c0_1[2]);
            var color1 = "rgb(" + r1 + "," + g1 + "," + b1 + ")";

            var r2 = Math.round(istep * c1_0[0] + step * c1_1[0]);
            var g2 = Math.round(istep * c1_0[1] + step * c1_1[1]);
            var b2 = Math.round(istep * c1_0[2] + step * c1_1[2]);
            var color2 = "rgb(" + r2 + "," + g2 + "," + b2 + ")";

            $('#gradient').css({
                background: "-webkit-gradient(linear, left top, right top, from(" + color1 + "), to(" + color2 + "))"
            }).css({
                background: "-moz-linear-gradient(left, " + color1 + " 0%, " + color2 + " 100%)"
            });

            step += gradientSpeed;
            if (step >= 1) {
                step %= 1;
                colorIndices[0] = colorIndices[1];
                colorIndices[2] = colorIndices[3];

                //pick two new target color indices
                //do not pick the same as the current one
                colorIndices[1] = (colorIndices[1] + Math.floor(1 + Math.random() * (colors.length - 1))) % colors.length;
                colorIndices[3] = (colorIndices[3] + Math.floor(1 + Math.random() * (colors.length - 1))) % colors.length;

            }
        }

        setInterval(updateGradient, 10);
    }, [])

    return (
        <div className='home'>
            <img className="icon" src="https://dl.newwebinar.ir/base/logo.png" alt="icon" />
                            {getTotalOff == 0 ? null : (

                    <div id="gradient" style={{marginTop:"50px"}}>
                        <div>
                            <span>{getTotalOff.name}</span>
                            <span style={{ color: "green" }}>

                                <Countdown date={getTotalOff.date * 1000 + getTotalOff.time * 60 * 60 * 1000} />
                            </span>
                        </div>
                    </div>
                )}
            {/* <h1>موسسه نیو وبینار</h1> */}
            <div className='nav-list'>
                <Link to={'/webinars'}>
                    <img src="https://dl.newwebinar.ir/base/webinars.png" alt="webinars" />
                    <span>دوره های آموزشی</span>
                </Link>
                <Link to={'/files'}>
                    <img src="https://dl.newwebinar.ir/base/files.png" alt="files" />
                    <span>دوره های آفلاین</span>
                </Link>
                <Link to={"/journals"}>
                    <img src="https://dl.newwebinar.ir/base/blog.png" alt="journals" />
                    <span>نشریات دانشگاهی</span>
                </Link>
                <Link to={'/conferences'}>
                    <img src="https://dl.newwebinar.ir/base/visit.jpg" alt="visit" />
                    <span>همایش ها و کنگره ها</span>
                </Link>
                <Link to={'/books'}>
                    <img src="https://dl.newwebinar.ir/base/books.png" alt="books" />
                    <span>کتاب ها</span>
                </Link>

                <Link to={'/contactUs'}>
                    <img src="https://dl.newwebinar.ir/base/contact-us.jpg" alt="contact-us" />
                    <span>تماس با ما</span>
                </Link>

                {/* <Link to={'/teammate'}>
                    <img src="https://dl.newwebinar.ir/base/about-us.jpg" alt="teammate" />
                    <span>همکاران ما</span>
                </Link> */}




            </div>
            

            {user.value == "" ? (
                <>
                    <Link to={'/register'} className='account'>ثبت نام</Link>
                    <Link to={'/login'} className='account' style={{ top: "75px" }}>ورود</Link>
                </>
            ) : (

                <>
                    <Link to={'/dashboard'} className='account'>حساب کاربری</Link>
                    <Link to={'/logOut'} className='account' style={{ top: "75px" }}>خروج</Link>
                </>
            )}
        </div>
    )
}


export default Home